import React from 'react'
import { string, object } from 'prop-types'
import styled from 'styled-components'
import media from 'styled-media-query'

import { white } from '../colors'

const BadgeContainer = styled.div`
  display: flex;
  align-items: center;
  background: rgba(51, 222, 255, 0.2);
  border-radius: 50px;
  width: fit-content;
  padding: 0px 15px;
  height: 35px;

  ${media.greaterThan('medium')`
    height: 45px;
  `}

  > span {
    font-size: 11.6578px;
    line-height: 22px;
    color: ${white};
    line-height: 26px;
    margin-left: 10px;

    ${media.greaterThan('medium')`
      font-size: 14px;
      line-height: 26px;
    `}
  }
`

const BadgeAside = styled.div`
  font-size: 11.6578px;
  line-height: 22px;
  font-weight: bold;
  color: ${white};
  width: fit-content;
  padding: 2px 10px;
  border-radius: 50px;
  background-color: #33deff;
  display: flex;
  justify-content: center;
  align-items: center;

  ${media.greaterThan('medium')`
    font-size: 14px;
    line-height: 26px;
    padding: 5px 15px;
  `}
`

const Badge = ({ badge, content, style, className }) => (
  <BadgeContainer style={style} className={className}>
    <BadgeAside>{badge}</BadgeAside>
    <span>{content}</span>
  </BadgeContainer>
)

Badge.propTypes = {
  badge: string,
  content: string,
  className: string,
  style: object
}

export default Badge
